import styled from "styled-components";

const backgroundColor = ({ theme }) => {
  return theme.colors.primary.vividCerulean;
};

const disabledBackgroundColor = ({ theme }) => {
  return theme.colors.neutral.gray2;
};

const fontSize = ({ size }) => {
  switch (size) {
    case "regular":
      return "16px";
    default:
      return "14px";
  }
};

const focusBorderColor = ({ theme }) => {
  return theme.colors.feedbackState.info.hover;
};

const color = ({ disabled, theme }) => {
  if (disabled) return theme.colors.neutral.gray6;

  return theme.colors.primary.cetaceanBlue;
};

export const Wrapper = styled.label`
  border: none;
  color: ${color};
  display: grid;
  gap: 8px;
  grid-template-columns: 16px auto;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "300px")};
  position: relative;
`;

export const TextLabel = styled.p`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: ${fontSize};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  line-height: 20.4px;
  letter-spacing: 0.02em;
  text-align: left;
`;

export const HiddenCheckboxStylesStructure = styled.input`
  accent-color: ${backgroundColor};
  font-size: ${fontSize};
  border: none;
  border-radius: 4px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;

  &:focus {
    /* border: 1px solid ${focusBorderColor}; */
    display: block;
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    accent-color: ${disabledBackgroundColor};
  }
`;

export const CheckboxDisplayed = styled.div`
  display: grid;
  place-content: center;
  width: 100%;
  aspect-ratio: 1;
  background-color: ${({ checked, theme }) =>
    checked ? theme.colors.primary.vividCerulean : theme.colors.neutral.white};
  border-radius: 4px;
  border: ${({ checked, theme }) =>
    checked ? `none` : `1px solid ${theme.colors.neutral.gray4}`};
`;
